import { Group, Code } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useUserData } from 'hooks/api/useUser';
import { GroupBadge } from 'components/GroupBadge';
import { UnitType } from 'models/generic';
import { WeightDetails } from './WeightDetails';

export const useSymptomsName = (symptoms?: string[]) => {
  const { t } = useTranslation();
  if (!symptoms)
    return (
      <Group>
        <Code bg={'var(--mantine-color-gray-3)'}>{t('symptom_no_symptoms')}</Code>
      </Group>
    );

  return (
    <Group>
      {symptoms.map((symp) => (
        <Code key={`symptom-${symp}`} bg={'var(--mantine-color-gray-3)'}>
          {t(`symptom_${symp}`)}
        </Code>
      ))}
    </Group>
  );
};

export const useGroupNameById = (groupIds?: string[]) => {
  const { data: userData } = useUserData();

  const userGroupList = userData?.visibleGroups;

  if (groupIds) {
    const allFoundGroups = groupIds?.map((groupId) => {
      return userGroupList?.find((group) => group.id === groupId) || '';
    });

    return (
      <Group>
        {allFoundGroups.map((group) => {
          if (group) {
            return <GroupBadge label={group.name} key={group.id} groupId={group.id} />;
          }
          return '';
        })}
      </Group>
    );
  }
  return '';
};

export const renderWeightDetails = (props: { moreIds?: string[]; unitSystem: UnitType }) => {
  return <WeightDetails moreIds={props.moreIds} unitSystem={props.unitSystem} />;
};
